import {
  ContactOption,
  StripeAddressElementChangeEvent,
} from '@stripe/stripe-js';
import { Address } from '../models/address.model';

export function formatAddressLine2(
  city: string | undefined,
  province: string | undefined,
  postcode: string | undefined
) {
  return `${city}, ${province} ${postcode}`;
}

export function isSameContactOption(
  option1: ContactOption,
  option2: ContactOption | undefined
) {
  if (option2 == undefined) return false;

  return (
    option1.name === option2.name &&
    option1.address.city === option2.address.city &&
    option1.address.country === option2.address.country &&
    option1.address.line1 === option2.address.line1 &&
    option1.address.line2 === option2.address.line2 &&
    option1.address.postal_code === option2.address.postal_code &&
    option1.address.state === option2.address.state
  );
}

export function isSameAddress(
  ammAddress: Address,
  stripeAddress: StripeAddressElementChangeEvent
) {
  return (
    ammAddress.firstName === stripeAddress.value.name &&
    ammAddress.addressLine1 === stripeAddress.value.address.line1 &&
    (ammAddress.addressLine2 ?? '') ===
      (stripeAddress.value.address.line2 ?? '') &&
    ammAddress.city === stripeAddress.value.address.city &&
    ammAddress.province === stripeAddress.value.address.state &&
    ammAddress.country === stripeAddress.value.address.country &&
    ammAddress.postcode === stripeAddress.value.address.postal_code
  );
}
